// Only one item MUST have the "default: true" key

module.exports = {
  ca: {
    default: true,
    path: `ca`,
    title: `CAT`,
    locale: `ca-ES`,
    dateFormat: `dd/MM/yyyy`,
    siteLanguage: `ca`,
    ogLanguage: `ca_ES`,
    defaultTitle: "Càmping La Mola",
    defaultDescription:
      "Càmping situat a la zona del Parc Nacional d'Aigüestortes i Estany de Sant Maurici, l'enclavament ideal per relaxar-se i gaudir de privilegiats paisatges. Oferim àmplies parcel·les amb gespa i ombra, aixícom còmodes i espaiosos bungalows.",
  },
  es: {
    path: `es`,
    title: `ES`,
    locale: `es-ES`,
    dateFormat: `dd/MM/yyyy`,
    siteLanguage: `es`,
    ogLanguage: `es_ES`,
    defaultTitle: "Camping La Mola",
    defaultDescription:
      "Càmping situat a la zona del Parc Nacional d'Aigüestortes i Estany de Sant Maurici, l'enclavament ideal per relaxar-se i gaudir de privilegiats paisatges. Oferim àmplies parcel·les amb gespa i ombra, aixícom còmodes i espaiosos bungalows.",
  },
  en: {
    path: `en`,
    title: `ENG`,
    locale: `en-GB`,
    dateFormat: `MM/dd/yyyy`,
    siteLanguage: `en`,
    ogLanguage: `en_GB`,
    defaultTitle: "Camping La Mola",
    defaultDescription:
      "Càmping situat a la zona del Parc Nacional d'Aigüestortes i Estany de Sant Maurici, l'enclavament ideal per relaxar-se i gaudir de privilegiats paisatges. Oferim àmplies parcel·les amb gespa i ombra, aixícom còmodes i espaiosos bungalows.",
  },
  fr: {
    path: `fr`,
    title: `FR`,
    locale: `fr-FR`,
    dateFormat: `dd/MM/yyyy`,
    siteLanguage: `fr`,
    ogLanguage: `fr_FR`,
    defaultTitle: "Camping La Mola",
    defaultDescription:
      "Càmping situat a la zona del Parc Nacional d'Aigüestortes i Estany de Sant Maurici, l'enclavament ideal per relaxar-se i gaudir de privilegiats paisatges. Oferim àmplies parcel·les amb gespa i ombra, aixícom còmodes i espaiosos bungalows.",
  },
  nl: {
    path: `nl`,
    title: `NL`,
    locale: `nl-NL`,
    dateFormat: `dd/MM/yyyy`,
    siteLanguage: `nl`,
    ogLanguage: `nl_NL`,
    defaultTitle: "Camping La Mola",
    defaultDescription:
      "Càmping situat a la zona del Parc Nacional d'Aigüestortes i Estany de Sant Maurici, l'enclavament ideal per relaxar-se i gaudir de privilegiats paisatges. Oferim àmplies parcel·les amb gespa i ombra, aixícom còmodes i espaiosos bungalows.",
  },
}
